import AppConstants from "../../../Config/AppConstants";
import {fetchMenuList, fetchMovieByAlias} from "./requesApi";

export const getMenuList = async () => {

    let dataStorage = sessionStorage.getItem(AppConstants.menuStorage);
    if (dataStorage) {
        return JSON.parse(dataStorage);
    }

    let result = await fetchMenuList();

    if (!result || result.status != 200 || !result.data.data) {
        // window.location.replace("/error");
        return false;
    }

    sessionStorage.setItem(AppConstants.menuStorage, JSON.stringify(result.data.data));
    return result.data.data;
}

export const getMoviesByAlias = async (alias = '',params = '', page = 1, pageSort = '') => {


    let newParams = {...params};

    if(pageSort != '') {
        newParams.sort = pageSort;
    }

    let result = await fetchMovieByAlias(alias, newParams, page);

    if (!result || result.status != 200 || !result.data.data) {
        // window.location.replace("/error");
        return false;
    }
    return result.data.data;
}
